<template>
  <div class="commonflow">
    <el-form ref="formData" :model="formData" :rules="rules" label-position="left" size="small">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题" prop="title" label-width="80px">
            <el-input v-model.trim="formData.title" :disabled="flowStatus" maxlength="30" show-word-limit size="small"></el-input>
            <span slot="error" class="item-error">
              <span>请填写标题</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="专业" prop="specId" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.specId" size="small" style="width: 100%"
              clearable filterable :disabled="flowStatus" @change="change_showStartButtons">
              <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-input v-else v-model="formData.specName" disabled size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="阶段 " prop="stage" label-width="80px">
            <el-input v-model="formData.stage" :disabled="flowStatus" size="small" style="width: 100%" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="起讫时间" label-width="80px">
            <el-date-picker
              v-model="formData.daterange"
              style="width: 100%"
              size="small"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="flowStatus"
              @input="changeInsertShow">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联计划" prop="prjPlanId" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.prjPlanId" size="small" style="width: 100%" clearable filterable :disabled="flowStatus" @change="changePrjPlan" @focus="focusPrjPlan">
              <el-option v-for="item in prjPlanData" :key="item.taskId" :label="item.taskName" :value="item.taskId" />
            </el-select>
            <el-input v-else v-model="formData.prjPlanName" disabled size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="项目名称" label-width="80px">
            <el-input v-model="formData.prjName" :disabled="flowStatus" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目编号" label-width="80px">
            <el-input v-model="formData.prjCode" :disabled="flowStatus" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="申请人" label-width="80px">
            <el-input v-model="formData.operUserName" :disabled="flowStatus" size="small"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交时间" label-width="80px">
            <el-input v-model="formData.operTime" :disabled="flowStatus" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="内容" prop="content" label-width="80px">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="line-height: 20px;margin-top:15px">
        <el-col :span="24">
          <el-form-item label="附件" label-width="80px">
            <div style="float:left">
              <el-button :disabled="flowStatus" size="small" @click="uploadFolder('guanlianfile')"> <i class="el-icon-plus"></i>关联文档</el-button>
              <el-button :disabled="flowStatus" size="small" @click="uploadFolder('file')"> <i class="el-icon-plus"></i>本地上传</el-button>
            </div>
            <el-button v-if="flowStatus" style="float: right;" type="text" @click="refresh">刷新轻量化状态</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 通用关联文件 -->
    <el-dialog v-dialogDrag :visible.sync="fileDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :close="cancel" title="关联文件" width="600px">
      <el-tree ref="localTree" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" :class="[{ activeShowBar: !showBar }]" class="tree" lazy accordion highlight-current
        show-checkbox @check="currentOrgChangeHandlerLocal">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer">
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>
    <uploader ref="uploader" type-key="4" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import uploader from "@/CommonDP/components/UploaderForPerFileDan/Uploader";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import flowService from "@/CommonDP/service/flow-service";
export default {
  components: { uploader },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => []
    },
    // 流程版本号。与 flowKey 两者不可同时为空
    flowDefinitionId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      formData: {
        title: "",
        content: "",
        specId: '',
        specName: '',
        prjPlanId: '',
        prjPlanName: '',
        stage: '',
        daterange: [],
        startDate: '',
        endDate: ''
      },
      readonly: false, // 用以替换 flowStatus
      flowStatus: false,
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }]
        // content: [{ required: true, message: "请填写内容", trigger: "blur" }]
      },
      node_had: {},
      resolve_had: {},
      fileDialog: false,
      localTree: [],
      icon: "",
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      prjPlanData: [],
      specList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    showBar() {
      return this.$store.state.app.showBar;
    },
    tableData() {
      return this.list || [];
    }
  },
  watch: {
    "formData.specId"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = '';
        this.formData.prjPlanName = '';
        this.prjPlanData = [];
      }
    }
  },
  created() {
    this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
    this.getSpecList();
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
    // 接口：用于获取表单数据
    getFormData() {
      this.formData.startDate = this.formData.daterange ? this.formData.daterange[0] : '';
      this.formData.endDate = this.formData.daterange ? this.formData.daterange[1] : '';
      return this.formData;
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
      this.formData.daterange = this.formData.startDate ? [this.formData.startDate, this.formData.endDate] : [];
    },

    // 接口：校验表单数据
    validateFormData() {
      //  return true;
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },
    async uploadFolder(type) {
      if (type === "guanlianfile") {
        this.node_had.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
        this.getlocalTree(this.node_had, this.resolve_had); // 再次执行懒加载的方法
        this.fileDialog = true;
      } else {
        const params = {
          prjId: this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId,
          folderId: "",
          versionId: ""
        };
        this.$refs.uploader.openUploader(params);
        // this.$store.dispatch("LocalUploadFloderData", this.tableData);
        // this.$store.dispatch("LocalUploadType", new Date().getTime());
      }
    },
    async getlocalTree(node, resolve) {
      const prjId = this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderId }) => folderId !== "recycle");
        const array = list.map(item => {
          const { childFolder = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            status: item.status,
            uploadType: 2,
            fileVersion: item.fileVersion,
            leaf: childFolder === 0
          };
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        await docService.queryTree(params).then(({ data }) => {
          const list = data.map(item => {
            const { childFolder = 0 } = item;
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              status: item.status,
              leaf: childFolder === 0,
              fileVersion: item.fileVersion,
              uploadType: 2
            };
          });
          return resolve(list);
        });
      }
    },
    className(row) {
      return tableRowIcon(row);
    },
    async currentOrgChangeHandlerLocal(val, currentChecked) {
      this.currentFileLocal = currentChecked.checkedNodes;
    },
    async filerecelocationBtn() {
      // 对于通用流程关联文档，确定获取文件夹的子级文件
      if (this.currentFileLocal && this.currentFileLocal.length > 0) {
        const list = [];
        // 对于直接选择文件可以先拿出来
        const array = this.currentFileLocal.filter(({ isFolder }) => isFolder === 0);
        const arrayFolder = this.currentFileLocal.filter(({ isFolder }) => isFolder !== 0);
        const array11 = array.map(item => {
          return {
            fileName: item.folderName,
            fileId: item.folderId,
            fileType: item.fileType,
            isFolder: item.isFolder,
            status: item.status,
            versionIds: item.fileVersion,
            uploadType: 2
          };
        });
        // 选中的文件夹点击确定获取子级数据
        for (const item of arrayFolder) {
          const params = {
            folderId: item.folderId,
            isRead: item.isRead,
            priviAll: item.priviAll,
            noRightClickMenu: true,
            prjId: this.prjInfo.prjId || this.routerParams.prjId
          };
          await docService.queryTree(params).then(({ data }) => {
            const listData = data.map(item => {
              return {
                fileName: item.folderName,
                fileId: item.folderId,
                fileType: item.fileType,
                isFolder: item.isFolder,
                status: item.status,
                versionIds: item.fileVersion,
                uploadType: 2
              };
            });
            list.push.apply(list, listData);
          });
        }
        // 将获取到的非文件过滤掉
        const listLocal = list.filter(({ isFolder }) => isFolder === 0);
        // 拼接原来选择的文件
        const floderDatanew = array11.concat(listLocal);
        // 过滤一下重复的
        const res = new Map();
        this.floderData = floderDatanew.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
        this.$emit("tableshow", this.floderData || []);
      }
      this.fileDialog = false;
    },
    cancel() {
      this.localTree = [];
    },
    async getSpecList() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.querySpecList(prjID);
      if (res.data) this.specList = res.data.flowSpecPoList || [];
    },
    async getPlanTaskList() {
      const specId = this.formData.specId || '';
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.prjPlanTaskFlowList(this.flowDefinitionId, specId, prjID);
      if (res.data) this.prjPlanData = res.data || [];
    },
    change_showStartButtons(val) {
      this.$emit("change_showStartButtons");
      this.formData.prjPlanId = '';
      this.formData.prjPlanName = '';
      if (val) {
        this.formData.specName = this.specList.find((ele) => ele.id === val).name;
      } else {
        this.formData.specName = "";
      }
    },
    changePrjPlan(val) {
      if (val) {
        this.formData.prjPlanName = this.prjPlanData.find((ele) => ele.taskId === val).taskName;
      } else {
        this.formData.prjPlanName = "";
      }
    },
    focusPrjPlan() {
      if (!this.formData.specId) {
        this.$message.warning("请先选择专业");
      }
    },
    changeInsertShow() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.commonflow{
  .el-form-item{
    margin-bottom:5px;
    /deep/ .el-form-item__label{
      line-height: 32px;
    }
    /deep/ .el-form-item__content{
      line-height: 13px;
    }
  }
  .item-error{
    display: inline-block;
    color: #F56C6C;
    font-size: 12px;
  }
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
</style>
